/**
 * Safely join URL paths, handling trailing/leading slashes
 */
export function joinUrlPath(base: string, ...paths: string[]): string {
  // Remove trailing slash from base
  let result = base.replace(/\/+$/, '');
  
  for (const path of paths) {
    // Remove leading and trailing slashes from path segment
    const cleanPath = path.replace(/^\/+|\/+$/g, '');
    if (cleanPath) {
      result += '/' + cleanPath;
    }
  }
  
  return result;
}

/**
 * Get the base URL (origin + pathname without trailing slash)
 */
export function getBaseUrl(): string {
  if (typeof window === 'undefined') {
    return '';
  }
  return window.location.origin + window.location.pathname.replace(/\/+$/, '');
}

/**
 * Build a URL relative to the current page
 */
export function buildRelativeUrl(...paths: string[]): string {
  return joinUrlPath(getBaseUrl(), ...paths);
}
